import styled from 'styled-components';
import { BaSeTheme } from '@base/react';

const {
  institucionais: { azulSebrae, cinzaSebrae75 },
} = BaSeTheme.colors;

const {
  tablet,
  mediaQueries: { mediaQueryCssUpTo },
} = BaSeTheme.breakpoints;

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  min-height: 56px;
  padding: 8px 0;
`;

export const Content = styled.div`
  padding: 0 1em;
  border-bottom: 1px solid #e8e8e8;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.span`
  font-family: 'Campuni', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: ${azulSebrae};
  white-space: nowrap;
`;

export const Divider = styled.div`
  width: 1px;
  height: 20px;
  background-color: ${cinzaSebrae75};
  flex-shrink: 0;

  ${mediaQueryCssUpTo(tablet)(`
    display: none;
  `)}
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;

  ${mediaQueryCssUpTo(tablet)(`
    margin-left: 0;
    width: 100%;
  `)}
`;

export const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const BadgeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;
